<template>
	<div class="main" v-loading.fullscreen="isLoad" element-loading-background="rgba(0, 0, 0,0)">
		<el-page-header @back="goBack" :content="id ? '编辑店铺' : '添加店铺'"></el-page-header>
		<el-form label-position="right" :rules="rules" ref="ruleForm" :model="item" label-width="auto">
			<el-form-item label="所属区域" prop="areaId">
				<el-select v-model="item.provinceId" clearable placeholder="请选择省" @change="provinceChange"
					style="margin-right: 20px;">
					<el-option v-for="item in province" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="item.cityId" clearable placeholder="请选择市" @change="cityChange"
					style="margin-right: 20px;">
					<el-option v-for="item in city" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="item.countyId" clearable placeholder="请选择县">
					<el-option v-for="item in county" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="店铺等级" prop="store_rank_id">
				<el-select v-model="item.store_rank_id" filterable placeholder="请选择店铺等级">
					<el-option v-for="item in optionsLevel" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="店铺名称" prop="name">
				<el-input v-model="item.name" placeholder="请输入店铺名称" :disabled="id ? true : false"></el-input>
			</el-form-item>
			<el-form-item label="店铺地址" prop="address">
				<el-input v-model="item.address" placeholder="请输入店铺地址"></el-input>
			</el-form-item>
			<el-form-item label="LOGO" prop="logo">
				<el-upload
						class="single-image"
						list-type="single-image"
						:on-success="(value) => uploadSuccess('logo', value)"
						:show-file-list="false"
						:action="app_url + '/admin/uploader/upload'">
					<i class="icon el-icon-plus" v-if="!item.logo"></i>
					<img :src="item.logo" v-else>
				</el-upload>
			</el-form-item>
			<el-form-item label="登录账号" prop="mobile">
				<el-input v-model="item.mobile" placeholder="请输入手机号码" :disabled="id ? true : false"></el-input>
			</el-form-item>
			<el-form-item label="登录密码" v-if="!id" prop="password">
				<el-input show-password v-model="item.password" placeholder="请输入登陆密码"></el-input>
			</el-form-item>
			<el-form-item label="预存款" prop="front_fee">
				<el-input v-model="item.front_fee" placeholder="请输入预存款"></el-input>
			</el-form-item>
			<el-form-item label="授信额度" prop="credit_fee">
				<el-input v-model="item.credit_fee" placeholder="请输入授信额度"></el-input>
			</el-form-item>
			<el-form-item label="授信周期" prop="credit_day">
				<el-input v-model="item.credit_day" placeholder="请输入授信周期(天)"></el-input>
			</el-form-item>
			<el-form-item label="授信起始日期" prop="credit_start">
				<el-date-picker
				      v-model="item.credit_start"
				      type="date"
				      placeholder="请输入授信起始日期"
					  format="yyyy 年 MM 月 dd 日"
					   value-format="yyyy-MM-dd">
				    </el-date-picker>
			</el-form-item>
			<el-form-item label="商品分类设置">
				<el-radio v-model="item.product_category_level" label="1">一级分类</el-radio>
				<el-radio v-model="item.product_category_level" label="2">二级分类</el-radio>
				<el-radio v-model="item.product_category_level" label="3">三级分类</el-radio>
			</el-form-item>
			<el-form-item label="是否开启积分充值">
				<el-switch
						v-model="item.jifen_recharge"
						active-color="#13ce66"
						active-value="1"
						inactive-value="0">
				</el-switch>
			</el-form-item>
			<el-form-item label="是否开启会员自由注册">
				<el-switch
						v-model="item.free_register"
						active-color="#13ce66"
						active-value="1"
						inactive-value="0">
				</el-switch>
			</el-form-item>
			<el-form-item label="是否开启H5端">
				<el-switch
						v-model="item.h5_open"
						active-color="#13ce66"
						active-value="1"
						inactive-value="0">
				</el-switch>
			</el-form-item>
			<el-form-item label="H5端地址" prop="h5_url">
				<el-input v-model="item.h5_url" placeholder="请输入"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="big" type="primary" @click="checkSubmit">保存</el-button>
			</el-form-item>

			<el-form-item>
				<el-dialog title="提示" :visible.sync="dialogVisible" width="30%">
					<span>确认保存？</span>
					<span slot="footer" class="dialog-footer">
						<el-button @click="dialogVisible = false">取 消</el-button>
						<el-button type="primary" @click="submit">确 定</el-button>
					</span>
				</el-dialog>
			</el-form-item>
		</el-form>
	</div>
</template>
<script>
	import 'quill/dist/quill.core.css'
	import 'quill/dist/quill.snow.css'
	import 'quill/dist/quill.bubble.css'
	import {
		quillEditor
	} from 'vue-quill-editor'

	export default {
		data() {
			return {
				item: {
					logo: '',
					product_category_level: '1',
					jifen_recharge: 0,
					free_register: 0
				},

				isLoad: false,
				id: this.$route.query.id,
				dialogVisible: false,
				province: [],
				city: [],
				county: [],
				logo: [],
				options: [],
				optionsLevel: [],
				optionsArea: [],
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'],
								['blockquote', 'code-block'],
								[{
									'header': 1
								}, {
									'header': 2
								}],
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}],
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}],
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}],
								[{
									'direction': 'rtl'
								}],
								[{
									'size': ['small', false, 'large', 'huge']
								}],
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}],
								[{
									'color': []
								}, {
									'background': []
								}],
								[{
									'font': []
								}],
								[{
									'align': []
								}],
								['clean'],
								['image', 'video']
							],
							handlers: {
								image: function(value) {
									if (value)
										document.querySelector('#quill-upload input').click()
									else
										this.quill.format('image', false);
								}
							}
						}
					},
				},
				rules: {
					business_id: [{
						required: true,
						message: '商家ID未选择',
						trigger: 'blur'
					}, ],
					store_rank_id: [{
						required: true,
						message: '店铺等级未选择',
						trigger: 'blur'
					}, ],
					address: [{
						required: true,
						message: '请输入地址',
						trigger: 'blur'
					}, ],
					// areaId: [
					//     { required: true,validator: this.$check.num, trigger: 'blur'},
					// ],
					mobile: [{
						required: true,
						validator: this.$check.mobile,
						trigger: 'blur'
					}, ],
					name: [{
						required: true,
						message: '请输入名称',
						trigger: 'blur'
					}, ],
					logo: [{
						required: true,
						message: 'logo不存在'
					}, ],
					credit_start: [{
						required: true,
						message: '请选择授信起始日期'
					}, ]
				}
			}
		},
		created() {
			this.gerProvince()
			this.loadData()
		},
		methods: {
			gerProvince() {
				let i = 0
				for (let key in this.$city.province_list) {
					let obj = {
						id: key,
						name: this.$city.province_list[key]
					}
					this.province[i++] = obj
				}
			},
			provinceChange(data) {
				this.city = []
				this.county = []
				this.$set(this.item, 'cityId', '')
				this.$set(this.item, 'countyId', '')
				let subPro = data.substring(0, 2)
				let subCity = ''
				let i = 0
				for (let key in this.$city.city_list) {
					subCity = key.substring(0, 2)
					if (subCity === subPro) {
						let obj = {
							id: key,
							name: this.$city.city_list[key]
						}
						this.city[i++] = obj
					}
				}
			},
			cityChange(data) {
				this.county = []
				this.$set(this.item, 'countyId', '')
				let subCity = data.substring(0, 4)
				let subCounty = ''
				let i = 0
				for (let key in this.$city.county_list) {
					subCounty = key.substring(0, 4)
					if (subCounty === subCity) {
						let obj = {
							id: key,
							name: this.$city.county_list[key]
						}
						this.county[i++] = obj
					}
				}
			},
			async loadData() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				let res = ""

				res = await this.axios.post('/admin/data/listStoreRankForSelect', {
				})
				this.optionsLevel = res.data.list
				if (this.id) {
					res = await this.axios.post('/admin/business.store/detail', {
						id: this.id
					})
					if (res) {
						// item是基础信息
						this.item = res.data.detail
						this.item.product_category_level = this.item.product_category_level.toString()
						this.item.jifen_recharge = this.item.jifen_recharge.toString()
						this.item.free_register = this.item.free_register.toString()
						this.item.h5_open = this.item.h5_open.toString()
					}
				}
				this.isLoad = !this.isLoad
			},
			// 后退一步
			goBack() {
				this.$router.back(-1)
			},
			checkSubmit() {
				// 存储图片且刷新 因为上传的和存储的图片不是同一个
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.dialogVisible = true
					} else {
						this.$message.warning("请检查表单信息是否正确");
						return false;
					}
				});
			},
			// 提交
			submit() {
				if (this.isLoad) {
					return
				}
				this.isLoad = !this.isLoad
				this.dialogVisible = false
				let url = ''
				if (this.id) {
					url = '/admin/business.store/update'
					this.item.id = this.id
				} else {
					url = '/admin/business.store/add'
				}
				this.axios.post(url, this.item)
					.then(() => {
						this.isLoad = !this.isLoad
						this.$message.success({
							message: '保存成功'
						});
						this.goBack()
					})
					.catch(() => {
						this.isLoad = !this.isLoad
					})
			},
			uploadError() {
				this.$message.error({
					message: '上传失败'
				});
			},
			beforeUpload(file) {
				var testmsg = file.type;
				const extension = (testmsg === "image/jpeg" || testmsg === "image/png");
				if (!extension) {
					this.$message({
						message: "上传文件只能是jpg或png格式!",
						type: "warning",
					});
				}
				return extension;
			},
			uploadSuccess(key, res, file) {
				this.item[key] = res.data.fileInfo.external_url
			},
			// 富文本图片上传
			editorSuccess(res) {
				let quill = this.$refs.quill.quill
				let length = quill.getSelection().index
				// 上传图片的路径
				quill.insertEmbed(length, 'image', res.data.fileInfo.external_url)
				quill.setSelection(length + 1)
				this.$message.success({
					message: '上传成功'
				});
			}
		},
		components: {
			quillEditor
		}
	}
</script>
<style scoped>
</style>
